// extracted by mini-css-extract-plugin
export default {"slot-button":"SlotButton_slot-button__AQQkc","pending-ring":"SlotButton_pending-ring__7NEbP","commit-pop":"SlotButton_commit-pop__4s4R2"};